import React from "react";
import {createRoot} from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { environment } from "./config";
// if (environment === "Production") {
//   console.log = () => {};  
// }

import axios from "axios";
import { setupInterceptors } from "./services/api";

setupInterceptors(axios);

const root = createRoot(document.getElementById("root"))
root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
  